const Data = {
  apiEndPoint: process.env.REACT_APP_API_URL,
  summaryapiEndPoint: process.env.REACT_APP_SUMMARY_API_URL,
  simulationEndPoint: process.env.REACT_APP_SIMULATION_API_URL,
  name: process.env.NODE_ENV,
  rootuser: process.env.REACT_APP_ROOT_USER,
  domain: process.env.REACT_APP_EMAIL_DOMAIN,
  show_simulation: process.env.REACT_APP_ENABLE_SIMULATION === 'yes' || false,
  show_recommendation: process.env.REACT_APP_ENABLE_RECOMMENDATION === 'yes' || false,
  show_severity: process.env.REACT_APP_ENABLE_ALERT_SEVERITY === 'yes' || true,
  show_status: process.env.REACT_APP_ENABLE_ALERT_STATUS === 'yes' || true,
  prefix_name: process.env.REACT_APP_UI_PREFIX_NAME || 'consumption-ui',
  prefix: process.env.REACT_APP_UI_PREFIX === 'yes' || false,
  form_auth: process.env.REACT_APP_FORM_AUTH === 'yes' || false,
  sso_auth: process.env.REACT_APP_SSO_AUTH === 'yes' || false,
  chat_recommendations:
    process.env.REACT_APP_CHAT_RECOMMENDATIONS ||
    '["Is GMV of phillipines higher than thailand?","which category is contributing the most to GMV in Singapore","In thailand which category has lowest contrubution to GMV?"]'
};

export default Data;
